import { render } from "./MyinvInvestment.vue?vue&type=template&id=efea7306&scoped=true&ts=true"
import script from "./MyinvInvestment.vue?vue&type=script&lang=ts"
export * from "./MyinvInvestment.vue?vue&type=script&lang=ts"

import "./MyinvInvestment.vue?vue&type=style&index=0&id=efea7306&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efea7306"]])

export default __exports__